import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import NotFound from 'components/NotFound';
import EntityEditPageSkeleton from 'components/EntityEditPageSkeleton';
import FormSkeleton from 'components/FormSkeleton';
import PageWithSidebar from 'components/PageWithSidebar';
import EntitySidebar from 'components/EntitySidebar';
import CategoryEditForm from 'components/CategoryEditForm';

import { withData } from 'lib';
import { SettingsCategoryEditPageQuery } from '__generated__/SettingsCategoryEditPageQuery.graphql';

const query = graphql`
  query SettingsCategoryEditPageQuery($id: ID!) {
    category(id: $id) {
      name

      ...CategoryEditForm_category
      ...EntitySidebar_entity
    }
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<SettingsCategoryEditPageQuery>;
};

type RouteParams = {
  id: string;
};

const breadcrumbs = [
  { link: '/settings', name: 'Nustatymai' },
  { link: '/settings/categories', name: 'Kategorijos' },
];

const SettingsCategoryEditPage: FC<Props> = ({ preloadedQuery }) => {
  const { category } = usePreloadedQuery<SettingsCategoryEditPageQuery>(
    query,
    preloadedQuery
  );

  if (!category) {
    return <NotFound />;
  }

  return (
    <PageWithSidebar
      sidebar={<EntitySidebar entity={category} />}
      breadcrumbs={[
        ...breadcrumbs,
        {
          name: category.name,
        },
      ]}>
      <CategoryEditForm category={category} />
    </PageWithSidebar>
  );
};

export default withData<SettingsCategoryEditPageQuery, RouteParams>({
  query,
  loading: (
    <EntityEditPageSkeleton breadcrumbs={breadcrumbs}>
      <FormSkeleton sections={1} />
    </EntityEditPageSkeleton>
  ),

  variables: ({ routeParams }) => ({
    id: routeParams.id,
  }),
})(SettingsCategoryEditPage);
